import React, { Component } from 'react';
import Header from "./header";
import Main from "./main";
import Footer from "./footer";

class Landing extends Component {
  
  render() {
    return (
        <div className="container">
        <Header />
        <Main />
        <Footer/>
        </div>
    );
  }
}

export default Landing;





// WEBPACK FOOTER //
// ./src/components/landing.js